import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const article1={
  'title':'创意，从增长再发现',
  'second_title':'巨量引擎营销中心总经理 王丁虓',
  'brief':'增长，是商业世界的永恒主题，但在过去的很多年中，广告创意与这个词总有着朦胧不明的关系。',
  'shortbrief':'增长，是商业世界的永恒主题，但在过去的很多年中，广告创意与这个词总有着朦胧不明的关系。',
  'share_title':'创意，从增长再发现',
  'share_des':'增长，是商业世界的永恒主题，但在过去的很多年中，广告创意与这个词总有着朦胧不明的关系。',
  'date':'2020-09-30'
}
const article2={
  'title':'新营销时代的增长创意（上）',
  'second_title':'第一财经 x 动见',
  'brief':'在“增长创意”理念的指导下，创意的辐射范围将远远超过传统营销所定义的范畴，并拓展至企业的产品内部，以及销售和运营等各个部门和领域。',
  'shortbrief':'增长是今天营销世界里绕不开的课题。',
  'share_title':'新营销时代的增长创意（上）',
  'share_des':'在“增长创意”理念的指导下，创意的辐射范围将远远超过传统营销所定义的范畴，并拓展至企业的产品内部，以及销售和运营等各个部门和领域。',
  'date':'2020-09-30'
}
const article3={
  'title':'新营销时代的增长创意（下）',
  'second_title':'第一财经 x 动见',
  'brief':'企业、用户、代理商、平台……在这场创意朝着“增长创意”进化的革命中，没有任何一方能够孤立前行，他们共同构成了一个有机共生的整体。',
  'shortbrief':'作为背后的颠覆者，巨量创意的出现恰逢其时。',
  'share_title':'新营销时代的增长创意（下）',
  'share_des':'企业、用户、代理商、平台……在这场创意朝着“增长创意”进化的革命中，没有任何一方能够孤立前行，他们共同构成了一个有机共生的整体。',
  'date':'2020-09-30'
}
const article4={
  'title':'创意的新可能',
  'second_title':'巨量引擎营销创意负责人 东东枪',
  'brief':'当广告被更加明确地与增长相关联、为增长而服务，“创意”也势必会被自然而然地置于一个更切实的语境之中、被全新的视角所审视打量。',
  'shortbrief':'“我们对于创意的很多认识，都需要更新一下了。”',
  'share_title':'创意的新可能',
  'share_des':'当广告被更加明确地与增长相关联、为增长而服务，“创意”也势必会被自然而然地置于一个更切实的语境之中、以全新的视角所审视打量。',
  'date':'2020-09-30'
}
const article5={
  'title':'用技术，解放创意',
  'second_title':'第一财经 x 动见',
  'brief':'短视频时代，媒介发生了根本性的改变。如今，创意在继承过去创意生产内核的基础上，因为科技与数据的加持，开始产生新的进化。',
  'shortbrief':'工具和技术，已经日渐成为了创意的新引擎。',
  'share_title':'用技术，解放创意',
  'share_des':'短视频时代，媒介发生了根本性的改变。如今，创意在继承过去创意生产内核的基础上，因为科技与数据的加持，开始产生新的进化。',
  'date':'2020-09-30'
}
const article6={
  'title':'数说：让创意巨量生产',
  'second_title':'第一财经 x 动见',
  'brief':'以下图表通过数据展示了巨量创意如何通过技术帮助创意提效，实现行业创意质量增长，推动创意生态建设。',
  'shortbrief':'一张图看懂巨量创意的生产全貌。',
  'share_title':'数说：让创意巨量生产',
  'share_des':'以下图表通过数据展示了巨量创意如何通过技术帮助创意提效，实现行业创意质量增长，推动创意生态建设。',
  'date':'2020-09-30'
}
const article7={
  'title':'数字时代的创意生产者',
  'second_title':'第一财经 x 动见',
  'brief':'乍看上去，传统4A广告和效果广告两大阵营在创意上追求明显不同，但它们都服务于一个共同的目标——生意增长。',
  'shortbrief':'乍看上去，传统4A广告和效果广告两大阵营在创意上追求明显不同，但它们都服务于一个共同的目标——生意增长。',
  'share_title':'数字时代的创意生产者',
  'share_des':'乍看上去，传统4A广告和效果广告两大阵营在创意上追求明显不同，但它们都服务于一个共同的目标——生意增长。',
  'date':'2020-09-30'
}
const article8={
  'title':'专访惠普董广鹏：数字营销时代如何做消费者洞察？',
  'second_title':'惠普大中华区首席市场营销官 董广鹏',
  'brief':'不论是“数字化”还是“多元化”，都指向了对于消费者更高效的触达和创意内容对生意的直接推动。',
  'shortbrief':'不论是“数字化”还是“多元化”，都指向了对于消费者更高效的触达和创意内容对生意的直接推动。',
  'share_title':'专访惠普董广鹏：数字营销时代如何做消费者洞察？',
  'share_des':'不论是“数字化”还是“多元化”，都指向了对于消费者更高效的触达和创意内容对生意的直接推动。',
  'date':'2020-09-30'
}
const article9={
  'title':'专访完美世界邓佩：用创意和数据促成“品效合一”',
  'second_title':'完美世界游戏副总裁 邓佩',
  'brief':'随着数据和洞察技术的发展，关于创意好坏的判断能更加透明和有据可依，能让广告主不只是知其然，更知其所以然，从黑盒变成白盒。',
  'shortbrief':'随着数据和洞察技术的发展，关于创意好坏的判断能更加透明和有据可依，能让广告主不只是知其然，更知其所以然，从黑盒变成白盒。',
  'share_title':'专访完美世界邓佩：用创意和数据促成“品效合一”',
  'share_des':'随着数据和洞察技术的发展，关于创意好坏的判断能更加透明和有据可依，能让广告主不只是知其然，更知其所以然，从黑盒变成白盒。',
  'date':'2020-09-30'
}
const article10={
  'title':'专访索菲亚王兵：用创意内容搭建多渠道营销阵地',
  'second_title':'索菲亚执行总裁 王兵',
  'brief':'如何让创意和营销更快速为销售赋能，最重要的是团队能力的搭建。',
  'shortbrief':'如何让创意和营销更快速为销售赋能，最重要的是团队能力的搭建。',
  'share_title':'专访索菲亚王兵：用创意内容搭建多渠道营销阵地',
  'share_des':'如何让创意和营销更快速为销售赋能，最重要的是团队能力的搭建。',
  'date':'2020-09-30'
}
const article11={
  'title':'专访东风日产张茂华：营销是连接品牌和用户的桥梁',
  'second_title':'东风日产市场部副部长 张茂华',
  'brief':'新的环境带来的是数据和创意理念上的变化，数据和技术解决了传统广告ROI无法直观衡量的痛点，为产品和营销决策提供更有力的洞察。',
  'shortbrief':'新的环境带来的是数据和创意理念上的变化，数据和技术解决了传统广告ROI无法直观衡量的痛点，为产品和营销决策提供更有力的洞察。',
  'share_title':'专访东风日产张茂华：营销是连接品牌和用户的桥梁',
  'share_des':'新的环境带来的是数据和创意理念上的变化，数据和技术解决了传统广告ROI无法直观衡量的痛点，为产品和营销决策提供更有力的洞察。',
  'date':'2020-09-30'
}

export default new Vuex.Store({
  state: {
    articles:[
      article1,article2,article3,article4,article5,
      article6,article7,article8,article9,article10,
      article11
    ],
    classes:["推荐","人物说"],
    class1:{
      marquees:[0],
      banner:[],
      list:[1,2,3,4,5]
    },
    class2:{
      marquees:[6],
      banner:[],
      list:[7,8,9,10]
    }
  },
  mutations: {
  }
})



// WEBPACK FOOTER //
// ./src/store/articlesStore_2.js